import React, { useContext } from 'react';
import { ProvidersContext } from './context';
import { RangeValidator as HoverRangeValidator } from './hover/range-validator';
import { SelectionRangeValidator } from './selection/range-validator';
export var AnnotationsContextWrapper = function AnnotationsContextWrapper(props) {
  var providers = useContext(ProvidersContext);
  var rendererRef = props.rendererRef,
    createAnalyticsEvent = props.createAnalyticsEvent,
    children = props.children;
  var inlineCommentProvider = providers && providers.inlineComment;
  var selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
  var hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
  if (!selectionComponent && !hoverComponent) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children, !!hoverComponent && /*#__PURE__*/React.createElement(HoverRangeValidator, {
    createAnalyticsEvent: createAnalyticsEvent,
    rendererRef: rendererRef
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    component: hoverComponent
  }), !!selectionComponent && /*#__PURE__*/React.createElement(SelectionRangeValidator, {
    createAnalyticsEvent: createAnalyticsEvent,
    rendererRef: rendererRef
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    selectionComponent: selectionComponent
  }));
};